module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAnUlEQVQ4y2NgGBSA0ajqPwjDwHkRbTAGAZgcNjycDPiPB5DkAmxY0L7pf1bbxv9HLjwA47Tm9f/5bRuJN6Bt3oH/JtFTwYacuvL4v3XijP/diw4RbwCzSfX/g2fv/7/75O3/B8/e/99/5h5YjCQvOKXN+T93w5n/01efBLMF7JqINwDmDY3APjBumbOftECE4eCSpf89cxZgj4WhDQA4/0zERqqe4gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/TF.png
// module id = 1276
// module chunks = 0